export default __webpack_public_path__ + "static/media/mentoring-alt.507eb282.jpg";